function useProductImage(images) {
  const imageUrl = images?.downloadLink;
  return imageUrl;
}

export default useProductImage;
